import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface AuthorCardProps {
  author: string;
  date: string;
}

const AuthorCard = ({ author, date }: AuthorCardProps) => (
  <Card className="p-6 lg:sticky lg:top-8 bg-slate-800 border-slate-700">
    <div className="flex flex-col items-center text-center">
      <div className="w-20 h-20 rounded-full bg-slate-700 mb-4 overflow-hidden">
        <img
          src={`https://api.dicebear.com/7.x/avataaars/svg?seed=${author}`}
          alt={author}
          className="w-full h-full object-cover"
        />
      </div>
      <h3 className="font-semibold text-lg mb-2 text-white">{author}</h3>
      <p className="text-sm text-gray-400 mb-4">Loch Ness Researcher</p>
      <div className="w-full h-px bg-slate-700 my-4" />
      <div className="text-sm text-gray-400">
        <p>Published on</p>
        <p className="font-medium text-white">{date}</p>
      </div>
      <Button className="w-full mt-4" variant="outline">
        Follow Researcher
      </Button>
    </div>
  </Card>
);

export default AuthorCard;